module.exports = __webpack_public_path__ + "static/media/Relative-Medium-Web.d9fdb0c4.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Medium-Web.woff2
// module id = 749
// module chunks = 0